import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/common/buttons'
import logo from '../../assets/imgs/logos/logo.svg'
import { appPathname, pathname } from '../../utils/constants/pathname'
import './landing.scss'

const Landing = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const auth = useSelector((state) => state.auth)
  const path = auth.user !== null ? appPathname.HOME : pathname.LOGIN
  const onClick = () => {
    navigate(path)
  }

  return (
    <div className="landing">
      <div className="landing-wrapper__radius">
        <div className="landing-box">
          <a href={path}>
            <img className="__img" alt="gesMoure" src={logo} />
          </a>
          <div className="landing-box-btn">
            <h2 className="title-landing">
              {intl.formatMessage({ id: 'landing.greetingMessage' })}
            </h2>
            <Button
              id="btnEnter"
              btnText="Entrar"
              btnClass="btn__with-bg-type-1"
              onHandleClick={() => onClick()}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Landing
